<template lang="pug">
Page.posts
    .posts__top(
        slot="header"
    )
        h1.posts__title
            | Блог компании

        .posts__subheader
            SvInput.posts__search(
                v-model="search"
                placeholder="Введите название ЖК"
                color="gray"
                size="large"
            )

            SvButton.posts__add(
                view="big"
                text="Добавить"
                :prependIcon=`{
                    icon: 'plus',
                    width: 17,
                    height: 17,
                    fillDefault: '#fff',
                    fillHover: '#fff'
                }`
                @click="transfer('new')"
            )

    SvTable.posts__table(
        :headers="headers"
        :body="getList"
        @transfer="(e) => transfer(e.id)"
    )
</template>

<script>

import { mapGetters } from 'vuex';
import { http } from '@/helpers/http';
import Page from '@/layouts/page.vue';
import SvInput from '@/components/uikit/SvInput.vue';
import SvButton from '@/components/uikit/SvButton.vue';
import SvTable from '@/components/uikit/SvTable.vue';

export default {
  name: 'Posts',

  beforeMount() {
    this.$store.dispatch('post/getList');

  },

  data() {
    return {
      headers: [
        {
          title: 'Заголовок',
          path: 'title',
          width: '30%',
        },
        {
          title: 'Просмотров',
          path: 'views_count',
          width: '20%',
        },
        {
          title: 'Просмотров(R)',
          path: 'views_count_real',
          width: '20%',
        },
        {
          title: 'Дата создания',
          path: 'created_at_formatted',
          width: '20%',
        },
        {
          title: 'Аквтивность',
          path: 'is_active',
          width: '10%',
        },
      ],
    };
  },

  computed: {
    ...mapGetters({
      getList: 'post/getList',
    }),

    search: {
      get() {
        return this.$store.state.post.search;
      },

      set(search) {
        this.$store.commit('post/setSearch', search);
      },
    },
  },

  methods: {
    transfer(id) {
      this.$router.push({
        name: 'post-edit',
        params: {
          id,
        },
      });
    },
  },

  mounted() {
  },

  components: {
    Page,
    SvInput,
    SvButton,
    SvTable,
  },
};
</script>

<style lang="scss">
.posts__title {
    margin: 10px 0 19px 0;
    font-size: 46px;
    font-weight: 500;
    color: #404450;
}

.posts__subheader {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.posts__search {
    width: 47%;
    min-width: 280px;
}

.posts__table {
    margin-top: 30px;
}
.sv-table__cell {
  overflow: hidden;
}

.sv-table__row .sv-table__cell:nth-child(2) {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    height: 44px;
    padding-top: 10px;
    padding-right: 15px;
    align-items: flex-start;
    justify-content: center;
}
</style>
